import $ from "./adminBase";

export default {
    addRole( data ) {
        return $.post("/system/role", data );
    },

    editRole( data ) {
        return $.put("/system/role", data );
    },

    roleList( data ) {
        return $.get("/system/role/list", data );
    },

    roleDataById( id ) {
        return $.get("/system/role/"+id );
    },

    delRole( id ){
        return $.delete("/system/role/"+id );
    },

    //  绑定菜单
    roleBindMenu( data ){
        return $.post("/system/role/bind/menu",data);
    },

     // 绑定菜单
     getBindMenu( roleId ){
        return $.get("/system/role/query/menu/"+roleId);
    },
};
